'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6,
    _t7,
    _t8,
    _t9;

import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import UIImage from 'UIComponents/image/UIImage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import GYASI_BLOB from 'bender-url!pricing-pages-unified-ui/img/peopleBlobs/gyasi.jpg';
import COMBINED_BLOB from 'bender-url!pricing-pages-unified-ui/img/peopleBlobs/combined.jpg';
import breakpoint from '../../utils/responsiveBreakpoints';
const Title = styled.h1.withConfig({
  displayName: "CustomerSupport__Title",
  componentId: "r63997-0"
})(["font-weight:bold;line-height:44px;", ";"], breakpoint.phone(_t || (_t = _`
    font-size: 30px;
  `)));
export const CustomerSupportContainer = styled.div.withConfig({
  displayName: "CustomerSupport__CustomerSupportContainer",
  componentId: "r63997-1"
})(["z-index:1;display:flex;flex-direction:row;align-items:center;width:100%;max-width:1200px;margin:0 auto;margin-top:40px;", ";"], breakpoint.sd(_t2 || (_t2 = _`
    margin-top: 70px;
    margin-bottom: 20px;
  `)));
const WordWrapper = styled.div.withConfig({
  displayName: "CustomerSupport__WordWrapper",
  componentId: "r63997-2"
})(["margin-left:auto;width:580px;", ";", ";"], breakpoint.sd(_t3 || (_t3 = _`
    width: 65%;
    margin-top: 0;
  `)), breakpoint.tabletPortrait(_t4 || (_t4 = _`
    width: 100%;
  `)));
const CustomerSupportMicroCopy = styled(Small).withConfig({
  displayName: "CustomerSupport__CustomerSupportMicroCopy",
  componentId: "r63997-3"
})(["text-transform:uppercase;font-weight:500;"]);
const IconsWrapper = styled(UIGrid).withConfig({
  displayName: "CustomerSupport__IconsWrapper",
  componentId: "r63997-4"
})(["text-align:center;margin-top:49px;margin-left:-32px !important;margin-right:0 !important;", ";"], breakpoint.phone(_t5 || (_t5 = _`
    flex-direction: column;
    margin-left: 0 !important;
    > div {
      display: flex;
      flex-direction: row-reverse;
      width: 100%;
      max-width: 100%;
      justify-content: flex-end;
      padding: 0;
      margin-bottom: 16px;
    }
    h5 {
      font-size: 1em;
      margin-left: 1em;
      text-align: left;
    }
  `)));
const DesktopImage = styled(UIImage).withConfig({
  displayName: "CustomerSupport__DesktopImage",
  componentId: "r63997-5"
})(["", ""], breakpoint.sd(_t6 || (_t6 = _`
    display: none !important;
  `)));
const MobileImage = styled(UIImage).withConfig({
  displayName: "CustomerSupport__MobileImage",
  componentId: "r63997-6"
})(["display:none !important;", " ", ";", ""], breakpoint.sd(_t7 || (_t7 = _`
    display: block !important;
  `)), breakpoint.tablet(_t8 || (_t8 = _`
    margin-left: -6%;
  `)), breakpoint.tabletPortrait(_t9 || (_t9 = _`
    display: none !important;
  `)));

function CustomerSupport({
  className
}) {
  return /*#__PURE__*/_jsxs(CustomerSupportContainer, {
    "data-selenium-id": "customer-support-container",
    className: className,
    children: [/*#__PURE__*/_jsx(DesktopImage, {
      src: COMBINED_BLOB,
      width: 510,
      height: 703,
      loading: "lazy"
    }), /*#__PURE__*/_jsx(MobileImage, {
      src: GYASI_BLOB,
      width: 280,
      height: 337,
      loading: "lazy"
    }), /*#__PURE__*/_jsxs(WordWrapper, {
      children: [/*#__PURE__*/_jsx(CustomerSupportMicroCopy, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerSupport.title"
        })
      }), /*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerSupport.subtitle"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-bottom-8",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerSupport.description"
        })
      }), /*#__PURE__*/_jsxs(IconsWrapper, {
        children: [/*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            xs: 4
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerSupport.phoneAndEmail"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            color: EERIE,
            name: "calling",
            size: 28
          })]
        }), /*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            xs: 4
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerSupport.documentation"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            color: EERIE,
            name: "blog",
            size: 28
          })]
        }), /*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            xs: 4
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerSupport.community"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            color: EERIE,
            name: "lists",
            size: 28
          })]
        })]
      })]
    })]
  });
}

export default CustomerSupport;